import type { CustomTagProps } from 'rc-select/lib/BaseSelect';
import type { SizeType } from 'antd/lib/config-provider/SizeContext';
import type { SelectValue } from 'antd/lib/select';
import { StyledSelect } from './Select.styles';

function UISelect({ dropdownMatchSelectWidth = false, ...props }: any) {
  return <StyledSelect dropdownMatchSelectWidth={dropdownMatchSelectWidth} {...props} />;
}

UISelect.Option = StyledSelect.Option;

export { UISelect as Select };
export type { SelectProps, LabeledValue } from 'antd/lib/select';
export type SelectOptionType = {
  label: string;
  value: SelectValue;
  title?: string;
  key?: string | number;
};

export interface SelectTagProps extends CustomTagProps {
  size?: SizeType;
}
